import { render, staticRenderFns } from "./MethodCard.vue?vue&type=template&id=05eb4bf6&scoped=true&"
import script from "./MethodCard.vue?vue&type=script&lang=js&"
export * from "./MethodCard.vue?vue&type=script&lang=js&"
import style0 from "./MethodCard.vue?vue&type=style&index=0&id=05eb4bf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eb4bf6",
  null
  
)

export default component.exports